import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'accountVerification',
    loadChildren: () => import('@app/account-verification/account-verification/account-verification.module')
      .then(m => m.AccountVerificationModule)
  },
  {
    path: 'experiencingAnOutage',
    loadChildren: () => import('@app/tracker/experiencing-an-outage/experiencing-an-outage.module')
      .then(m => m.ExperiencingAnOutageModule)
  },
  {
    path: 'preparingForAnOutage',
    loadChildren: () => import('@app/tracker/preparing-for-an-outage/preparing-for-an-outage.module')
      .then(m => m.PreparingForAnOutageModule)
  },
  {
    path: 'landing',
    loadChildren: () => import('@app/landing/landing/landing.module').then(m => m.LandingModule),
  },
  {
    path: 'confirmation',
    loadChildren: () => import('@app/confirmation/confirmation/confirmation.module').then(m => m.ConfirmationModule),
  },
  {
    path: 'meterStatusCheck',
    loadChildren: () => import('@app/meter-status/meter-status-check/meter-status-check.module').then(m => m.MeterStatusCheckModule),
  },
  {
    path: 'gasOnly',
    loadChildren: () => import('@app/meter-status/time-out-error/time-out-error.module').then(m => m.TimeOutErrorModule)
  },
  {
    path: 'opcoPremiseAddress',
    loadChildren: () => import('@app/multi-premise/opco-premise-address/opco-premise-address.module').then(m => m.OpcoPremiseAddressModule)
  },
  {
    path: 'outageReported',
    loadChildren: () => import('@app/outages/outage-reported/outage-reported.module').then(m => m.OutageReportedModule)
  },
  {
    path: 'premiseCheck',
    loadChildren: () => import('@app/premise-check/premise-check/premise-check.module').then(m => m.PremiseCheckModule)
  },
  {
    path: 'report',
    loadChildren: () => import('@app/report/report.module').then(m => m.ReportModule)
  },
  {
    path: 'underConstruction',
    loadChildren: () => import('@app/under-construction/under-construction.module').then(m => m.UnderConstructionModule)
  },
  // MARK - fallback outages table
  {
    path: 'fallbackReport',
    loadChildren: () => import('@app/fallback-report/fallback-report.module').then(m => m.FallbackReportModule),
  },
  {
    path: '',
    redirectTo: 'report',
    pathMatch: 'full'
  },
  {
    path: 'outageTracker',
    loadChildren: () => import('@app/tracker/tracker.module').then(m => m.TrackerModule)
  },
  {
    path: 'outageMap',
    loadChildren: () => import('@app/outage-map/outage-map.module').then(m => m.OutageMapModule)
  },
  {
    path: 'tracker',
    redirectTo: 'outageTracker'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes /* , { enableTracing: true } */, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
